// TODO: use commonUtil.getApplicationRoutes()
const { applicationRoutes } = require('./applicationRoutesConfig');

const homeRoute = { displayName: 'Home', route: '' };
const grHomePageRoute = { displayName: 'Mesa de Regalos', route: applicationRoutes.home };
const searchEventPageRoute = { displayName: 'Buscar una mesa de regalos', route: applicationRoutes.searchEvent };
const searchEventResults = { displayName: 'Resultados de la tabla de regalos', route: applicationRoutes.giftTableList };
const CelebracionesPageRoute = { displayName: 'Celebraciones', route: applicationRoutes.eventDetailsCelebrations };
const OpenPageRoute = { displayName: 'Todo Tipo De Evento', route: applicationRoutes.eventStatusSuspendedForTime };
// event management routes
const eventAdminPageRoute = { displayName: 'Datos de mi evento', route: applicationRoutes.eventManagement };
const deliveryAddressesRoute = { displayName: 'Direcciones de entregas', route: applicationRoutes.eventManagement };
const deliveryPreferencesRoute = { displayName: 'Preferencias de entrega de regalos', route: applicationRoutes.eventManagement };
const giftForClosingRoute = { displayName: 'Regalo por cierre', route: applicationRoutes.eventManagement };
const celebrationCardRoute = { displayName: 'Tarjeta de festejado', route: applicationRoutes.eventManagement };
const contractRoute = { displayName: 'Contrato', route: applicationRoutes.eventManagement };
const myWalletRoute = { displayName: 'Mis monederos', route: applicationRoutes.eventManagement };
const giftForOpeningRoute = { displayName: 'Regalo por apertura', route: applicationRoutes.eventManagement };
// const editCelebrityRoute = { displayName: 'Editar datos de festejado', route: applicationRoutes.eventManagement };

// notification
const notificationsRoute = { displayName: 'Notificaciones', route: applicationRoutes.notificationDetails };

// Tools for my event
const toolsForEventRoute = { displayName: 'Herramientas para mi evento', route: applicationRoutes.toolsForMyEvent };
const guestListRoute = { displayName: 'Lista de invitados', route: applicationRoutes.guestList };
const tableManagementRoute = { displayName: 'Organizador de mesas', route: applicationRoutes.tableManagement };
const thingsToDoRoute = { displayName: 'Lista de tareas', route: applicationRoutes.toolsForMyEvent };
const excelFeedDataRoute = { displayName: 'Importación por Excel', route: applicationRoutes.excelFeedData };
const invitationCreationRoute = { displayName: 'Creación de invitación', route: '' };
const notificationLandingRoute = { displayName: 'Confirmación de asistencia', route: applicationRoutes.notificationLanding };

// Gift management routes
const giftManagementRoute = { displayName: 'Mi mesa de regalos', route: applicationRoutes.giftList }
const giftManagementHomeRoute = { displayName: 'Administración de Regalos', route: applicationRoutes.giftList };
const giftListGuestListRoute = { displayName: 'Lista de Regalos', route: applicationRoutes.giftListGuestView };
const blogsRoute = { displayName: 'Blog', route: applicationRoutes.Blog };
const preDeterminedListRoute = { displayName: 'Listas predeterminadas', route: applicationRoutes.predeterminedLists };
const preDeterminedListDetailRoute = { displayName: 'Nombre de la lista', route: applicationRoutes.predeterminedListsDetailss };

// Accounts
const accountStatusRoute = { displayName: 'Estado de cuenta', route: applicationRoutes.accountStatus };
const physicalGiftRoute = { displayName: 'Regalos físicos', route: applicationRoutes.physicalGifts };
const personalPurchaseRoute = { displayName: 'Compras personales', route: applicationRoutes.personalPurchases };
const electronicGiftRoute = { displayName: 'Regalos electrónicos', route: applicationRoutes.electronicsGift };
const accountPartialTransferenceRoute = { displayName: 'Retiros anticipados', route: applicationRoutes.accountsPartialTransfer };
const bonusDetailRoute = { displayName: 'Aproximado de bono a monedero', route: applicationRoutes.bonusDetails };
const registroRoute = { displayName: 'Registro', route: applicationRoutes.register };
// const createAccountRoute = { displayName: 'Registro', route: applicationRoutes.createAccount }; // Note: can use later
const allEventsRoute = { displayName: 'Todo tipo de evento', route: applicationRoutes.Blog };

// createEvent routes
const createWedding = { displayName: 'Crear mesa de regalos', route: applicationRoutes.createWedding }; //Boda
const createBaby = { displayName: 'Crear mesa de regalos', route: applicationRoutes.createBaby }; //Bebe
const createBaptisms = { displayName: 'Crear mesa de regalos', route: applicationRoutes.createBaptisms }; //Bautizo
const createXVYears = { displayName: 'Crear mesa de regalos', route: applicationRoutes.createXVYears }; //XV Años
const createReligious = { displayName: 'Crear mesa de regalos', route: applicationRoutes.createReligious }; //Ceremonias religiosas
const createOpenHouse = { displayName: 'Crear mesa de regalos', route: applicationRoutes.createOpenHouse }; //Open house
const createBirthday = { displayName: 'Crear mesa de regalos', route: applicationRoutes.createBirthday }; //Cumpleaños
const createMascotas = { displayName: 'Crear mesa de regalos', route: applicationRoutes.createMascotas }; //Mascotas
const createOtras = { displayName: 'Crear mesa de regalos', route: applicationRoutes.createOtras }; //Otros eventos

export const breadcrumbConfiguration = {
  // EventManagemnt
  [applicationRoutes.eventManagement]: {
    DatosDeMiEvento: [homeRoute, grHomePageRoute, giftManagementHomeRoute, eventAdminPageRoute],
    TarjetaDeFestejado: [homeRoute, grHomePageRoute, giftManagementHomeRoute, eventAdminPageRoute, celebrationCardRoute],
    Contrato: [homeRoute, grHomePageRoute, giftManagementHomeRoute, eventAdminPageRoute, contractRoute],
    MisMonederos: [homeRoute, grHomePageRoute, giftManagementHomeRoute, eventAdminPageRoute, myWalletRoute],
    RegaloPorCierre: [homeRoute, grHomePageRoute, giftManagementHomeRoute, eventAdminPageRoute, giftForClosingRoute],
    PreferenciaDeEntregaDeRegalos: [homeRoute, grHomePageRoute, giftManagementHomeRoute, eventAdminPageRoute, deliveryPreferencesRoute],
    DirecciónDeEntrega: [homeRoute, grHomePageRoute, giftManagementHomeRoute, eventAdminPageRoute, deliveryAddressesRoute],
    RegaloDeApertura: [homeRoute, grHomePageRoute, giftManagementHomeRoute, eventAdminPageRoute, giftForOpeningRoute],
  },

  // GiftList
  [applicationRoutes.giftList]: [homeRoute, grHomePageRoute, giftManagementRoute],
  [applicationRoutes.predeterminedListsDetails]: [homeRoute, grHomePageRoute, giftManagementHomeRoute, preDeterminedListRoute, preDeterminedListDetailRoute],
  [applicationRoutes.predeterminedLists]: [homeRoute, grHomePageRoute, giftManagementHomeRoute, preDeterminedListRoute],
  [applicationRoutes.giftListGuestView]: [homeRoute, grHomePageRoute, searchEventPageRoute, giftListGuestListRoute],

  // Createeventroutes
  [applicationRoutes.selectWhichMesa]: [homeRoute, grHomePageRoute],
  [applicationRoutes.openType]: [],
  [applicationRoutes.celebrationType]: [],
  [applicationRoutes.mesaType]: [],
  [applicationRoutes.createEvent]: [],
  [applicationRoutes.maxEvents]: [homeRoute, grHomePageRoute, giftManagementHomeRoute],
  [applicationRoutes.selectWhichMesaTableChoice]: [homeRoute, grHomePageRoute],
  [applicationRoutes.eventsMaxLimitReached]: [homeRoute, grHomePageRoute],
  // 1.Celebrations
  [applicationRoutes.createWedding]: [homeRoute, grHomePageRoute, createWedding],
  [applicationRoutes.createBaby]: [homeRoute, grHomePageRoute, createBaby],
  [applicationRoutes.createXVYears]: [homeRoute, grHomePageRoute, createXVYears],
  [applicationRoutes.createFirst_communion]: [],
  [applicationRoutes.createBaptisms]: [homeRoute, grHomePageRoute, createBaptisms],
  [applicationRoutes.createConfirmations]: [],
  [applicationRoutes.createReligious]: [homeRoute, grHomePageRoute, createReligious],
  [applicationRoutes.createBar_Mitzvah]: [],
  [applicationRoutes.createBat_Mitzvah]: [],
  // 2.OpenEvents
  [applicationRoutes.createOpenHouse]: [homeRoute, grHomePageRoute, createOpenHouse],
  [applicationRoutes.createMeetings]: [],
  [applicationRoutes.createAniversary]: [],
  [applicationRoutes.createBirthday]: [homeRoute, grHomePageRoute, createBirthday],
  [applicationRoutes.createFarewell]: [],
  [applicationRoutes.createOtras]: [homeRoute, grHomePageRoute, createOtras],
  [applicationRoutes.createMascotas]: [homeRoute, grHomePageRoute, createMascotas],
  [applicationRoutes.addDeliveryAddress]: [],
  [applicationRoutes.benefits]: [],

  // Browseandnavigate
  // [applicationRoutes.home]: [homeRoute, grHomePageRoute],
  [applicationRoutes.register]: [homeRoute, grHomePageRoute, registroRoute],
  [applicationRoutes.createAccount]: [],
  [applicationRoutes.createCoOwnerAccount]: [homeRoute, grHomePageRoute, giftManagementHomeRoute],
  [applicationRoutes.article]: [homeRoute, grHomePageRoute, toolsForEventRoute, thingsToDoRoute],
  [applicationRoutes.multipleEvents]: [],
  [applicationRoutes.eventStatusSuspendedForTime]: [homeRoute, grHomePageRoute, OpenPageRoute],
  [applicationRoutes.notificationDetails]: [homeRoute, grHomePageRoute, notificationsRoute],
  [applicationRoutes.inspiration]: [homeRoute, grHomePageRoute, blogsRoute],
  [applicationRoutes.eventDetailsTipoDe]: [homeRoute, grHomePageRoute, allEventsRoute],
  [applicationRoutes.eventDetailsCelebrations]: [homeRoute, grHomePageRoute, CelebracionesPageRoute],
  [applicationRoutes.searchEvent]: [homeRoute, grHomePageRoute, searchEventPageRoute],
  [applicationRoutes.giftTableList]: [homeRoute, grHomePageRoute, searchEventPageRoute, searchEventResults],

  // EventManagementTools
  [applicationRoutes.myInvitation]: [homeRoute, grHomePageRoute, toolsForEventRoute, invitationCreationRoute],
  [applicationRoutes.invitationTemplate]: [homeRoute, grHomePageRoute, toolsForEventRoute, invitationCreationRoute],
  [applicationRoutes.viewGuestTemplate]: [homeRoute, grHomePageRoute, toolsForEventRoute, invitationCreationRoute],
  [applicationRoutes.editInvitation]: [homeRoute, grHomePageRoute, toolsForEventRoute, invitationCreationRoute],
  [applicationRoutes.previewTemplate]: [homeRoute, grHomePageRoute, toolsForEventRoute, invitationCreationRoute],
  [applicationRoutes.guestList]: [homeRoute, grHomePageRoute, toolsForEventRoute, guestListRoute],
  [applicationRoutes.newGuest]: [homeRoute, grHomePageRoute, toolsForEventRoute, guestListRoute],
  [applicationRoutes.editGuest]: [homeRoute, grHomePageRoute, toolsForEventRoute, guestListRoute],
  [applicationRoutes.excelFeedData]: [homeRoute, grHomePageRoute, toolsForEventRoute, guestListRoute, excelFeedDataRoute],
  [applicationRoutes.importFromExcel]: [homeRoute, grHomePageRoute, toolsForEventRoute, guestListRoute, excelFeedDataRoute],
  [applicationRoutes.toolsForMyEvent]: [homeRoute, grHomePageRoute, toolsForEventRoute],
  [applicationRoutes.sendReminder]: [homeRoute, grHomePageRoute],
  [applicationRoutes.eventConfirmation]: [homeRoute, grHomePageRoute],
  [applicationRoutes.tableManagement]: [homeRoute, grHomePageRoute, toolsForEventRoute, tableManagementRoute],
  [applicationRoutes.downloadToPDF]: [],

  // Notification
  [applicationRoutes.notificationLanding]: [homeRoute, grHomePageRoute, notificationLandingRoute],

  // AccountSummary
  [applicationRoutes.accountStatus]: [homeRoute, grHomePageRoute, giftManagementHomeRoute, accountStatusRoute],
  [applicationRoutes.electronicsGift]: [homeRoute, grHomePageRoute, giftManagementRoute, electronicGiftRoute],
  [applicationRoutes.physicalGifts]: [homeRoute, grHomePageRoute, giftManagementRoute, physicalGiftRoute],
  [applicationRoutes.personalPurchases]: [homeRoute, grHomePageRoute, giftManagementRoute, personalPurchaseRoute],
  [applicationRoutes.bonusDetails]: [homeRoute, grHomePageRoute, giftManagementHomeRoute, accountStatusRoute, bonusDetailRoute],
  [applicationRoutes.accountsPartialTransfer]: [homeRoute, grHomePageRoute, giftManagementHomeRoute, accountStatusRoute, accountPartialTransferenceRoute],
};
